import React from "react";

export const appointmentsConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/appointments",
        component: React.lazy(() => import("./AppoinmentsTab")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/view-appointment",
        component: React.lazy(() => import("./AppViewAppointment")),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/appointment-success',
        component: React.lazy(() => import('./BookNewAppointment/AppAppointmentSuccess')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/edit-appointment',
        component: React.lazy(() => import('./EditAppointment')),
      },
    ],
  },

  {
    auth: ["user"],
    routes: [
      {
        path: "/view-other-services",
        component: React.lazy(() => import("./AppViewOtherServices")),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/reschedule-other-services',
        component: React.lazy(() => import('./OtherServicesList/RescheduleOtherServices')),
      },
    ],
  },
];
